import axios, {AxiosResponse} from "axios";

export default (email: string, password: string) =>
	axios.get(
		`${process.env.REACT_APP_CHAT_HOST}/Authorization/AdminToken`,
		{
			params: {
				email,
				password
			}
		}
	).then((response: AxiosResponse) => {
		const token: string = response.data
		return Promise.resolve(token)
	})
